import { all } from 'redux-saga/effects';
import dataLayerSagas from './DataLayer/sagas.js';

function* sagas() {
    yield all([
        ...dataLayerSagas
    ]);
}

export { sagas as default };
//# sourceMappingURL=sagas.js.map
